{
	"name": "cloudflare-pages-deploy",
	"version": "0.1.0",
	"description": "Unofficial JavaScript SDK for Cloudflare Pages, extracting deploy logic from Cloudflare Wrangler.",
	"keywords": [
		"assembly",
		"cli",
		"cloudflare",
		"compute",
		"wrangler"
	],
	"homepage": "https://github.com/samlfair/cloudflare-pages-deploy#readme",
	"bugs": {
		"url": "https://github.com/samlfair/cloudflare-pages-deploy/issues"
	},
	"license": "MIT OR Apache-2.0",
	"repository": {
		"type": "git",
		"url": "https://github.com/samlfair/cloudflare-pages-deploy.git",
		"directory": "packages/wrangler"
	},
	"files": [
		"wrangler-dist",
		"templates",
		"kv-asset-handler.js",
		"config-schema.json"
	],
	"main": "wrangler-dist/index.js",
	"types": "wrangler-dist/index.d.ts",
	"scripts": {
		"assert-git-version": "node -r esbuild-register scripts/assert-git-version.ts",
		"build": "pnpm run clean && pnpm tsup && pnpm run generate-json-schema",
		"check:type": "tsc -p ./tsconfig.json && tsc -p ./templates/tsconfig.json",
		"clean": "node -r esbuild-register ../../tools/clean/clean.ts wrangler-dist miniflare-dist emitted-types",
		"dev": "pnpm run clean && concurrently -c black,blue --kill-others-on-fail false \"pnpm tsup --watch src --watch ../containers-shared/src --watch ../cli\" \"pnpm run check:type --watch --preserveWatchOutput\"",
		"generate-json-schema": "node -r esbuild-register scripts/generate-json-schema.ts",
		"start": "pnpm run build && cross-env NODE_OPTIONS=--enable-source-maps ./bin/wrangler.js",
		"test": "dotenv -- pnpm run assert-git-version && cross-env NODE_OPTIONS=\"$(node scripts/node-options-for-tests.js)\" dotenv -- vitest",
		"test:ci": "cross-env NODE_OPTIONS=\"$(node scripts/node-options-for-tests.js)\" pnpm run test run",
		"test:debug": "pnpm run test --silent=false --verbose=true",
		"test:e2e": "dotenv -- vitest run -c ./e2e/vitest.config.mts",
		"test:watch": "pnpm run test --testTimeout=50000 --watch",
		"type:tests": "tsc -p ./src/__tests__/tsconfig.json && tsc -p ./e2e/tsconfig.json"
	},
	"dependencies": {
		"@cloudflare/kv-asset-handler": "workspace:*",
		"@cloudflare/unenv-preset": "workspace:*",
		"blake3-wasm": "2.1.5",
		"esbuild": "catalog:default",
		"miniflare": "workspace:*",
		"path-to-regexp": "6.3.0",
		"unenv": "2.0.0-rc.24",
		"workerd": "1.20260601.1"
	},
	"devDependencies": {
		"@aws-sdk/client-s3": "^3.721.0",
		"@bomb.sh/tab": "^0.0.12",
		"@cloudflare/cli-shared-helpers": "workspace:*",
		"@cloudflare/codemod": "workspace:*",
		"@cloudflare/containers-shared": "workspace:*",
		"@cloudflare/deploy-helpers": "workspace:*",
		"@cloudflare/pages-shared": "workspace:^",
		"@cloudflare/types": "6.18.4",
		"@cloudflare/workers-auth": "workspace:*",
		"@cloudflare/workers-shared": "workspace:*",
		"@cloudflare/workers-tsconfig": "workspace:*",
		"@cloudflare/workers-types": "catalog:default",
		"@cloudflare/workers-utils": "workspace:*",
		"@cloudflare/workflows-shared": "workspace:*",
		"@cspotcode/source-map-support": "0.8.1",
		"@netlify/build-info": "^10.5.1",
		"@sentry/node": "^7.86.0",
		"@sentry/types": "^7.86.0",
		"@sentry/utils": "^7.86.0",
		"@types/command-exists": "^1.2.0",
		"@types/esprima": "^4.0.3",
		"@types/glob-to-regexp": "^0.4.1",
		"@types/javascript-time-ago": "^2.0.3",
		"@types/json-diff": "^1.0.3",
		"@types/mime": "^3.0.4",
		"@types/minimatch": "^5.1.2",
		"@types/node": "catalog:default",
		"@types/node-forge": "^1.3.11",
		"@types/prompts": "^2.0.14",
		"@types/resolve": "^1.20.6",
		"@types/shell-quote": "^1.7.2",
		"@types/signal-exit": "^3.0.1",
		"@types/supports-color": "^8.1.1",
		"@types/ws": "^8.5.7",
		"@types/yargs": "^17.0.22",
		"@vitest/ui": "catalog:default",
		"@webcontainer/env": "^1.1.0",
		"am-i-vibing": "^0.4.0",
		"capnweb": "catalog:default",
		"chalk": "^5.2.0",
		"chokidar": "^4.0.1",
		"ci-info": "catalog:default",
		"cli-table3": "^0.6.3",
		"cloudflare": "^5.2.0",
		"cmd-shim": "^4.1.0",
		"command-exists": "^1.2.9",
		"concurrently": "^8.2.2",
		"date-fns": "^4.1.0",
		"devtools-protocol": "^0.0.1182435",
		"dotenv": "^16.3.1",
		"dotenv-expand": "^12.0.2",
		"empathic": "^2.0.0",
		"esprima": "4.0.1",
		"execa": "^6.1.0",
		"get-port": "^7.0.0",
		"glob-to-regexp": "^0.4.1",
		"https-proxy-agent": "7.0.2",
		"itty-time": "^1.0.6",
		"javascript-time-ago": "^2.5.4",
		"json-diff": "^1.0.6",
		"jsonc-parser": "catalog:default",
		"md5-file": "5.0.0",
		"mime": "^3.0.0",
		"minimatch": "^5.1.0",
		"mock-socket": "^9.3.1",
		"msw": "catalog:default",
		"node-forge": "^1.3.2",
		"open": "catalog:default",
		"p-queue": "^9.0.0",
		"patch-console": "^1.0.0",
		"pretty-bytes": "^6.0.0",
		"prompts": "^2.4.2",
		"qr": "^0.6.0",
		"recast": "0.23.11",
		"resolve": "^1.22.8",
		"rosie-skills": "^0.8.1",
		"semiver": "^1.1.0",
		"shell-quote": "^1.8.1",
		"signal-exit": "catalog:default",
		"smol-toml": "catalog:default",
		"source-map": "^0.6.1",
		"supports-color": "^9.2.2",
		"timeago.js": "4.0.2",
		"tree-kill": "catalog:default",
		"ts-dedent": "^2.2.0",
		"ts-json-schema-generator": "^1.5.0",
		"tsup": "8.3.0",
		"typescript": "catalog:default",
		"undici": "catalog:default",
		"vitest": "catalog:default",
		"vitest-websocket-mock": "^0.4.0",
		"ws": "catalog:default",
		"xxhash-wasm": "^1.0.1",
		"yaml": "^2.8.1",
		"yargs": "^17.7.2"
	},
	"peerDependencies": {
		"@cloudflare/workers-types": "catalog:default"
	},
	"peerDependenciesMeta": {
		"@cloudflare/workers-types": {
			"optional": true
		}
	},
	"optionalDependencies": {
		"fsevents": "2.3.3"
	},
	"engines": {
		"node": ">=22.0.0"
	},
	"volta": {
		"extends": "../../package.json"
	},
	"workers-sdk": {
		"prerelease": true
	}
}